import { CSSProperties } from 'react';
import { useActiveUserContext, useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';
import { useUserRouteMapperHook } from '@vivli/features/portal/infrastructure/hook';
import { NavTabsComponent } from '@vivli/features/portal/components';
import { Outlet } from 'react-router';
import { Color } from '@vivli/shared/theme';

const outletStyle: CSSProperties = {
    height: '100%',
    flex: '1 1 auto',
    backgroundColor: Color.LIGHT_GRAY,
    overflowY: 'hidden',
    overflowX: 'hidden'
};

export const PortalFeature = () => {
    const { user } = useActiveUserContext();
    const { isAmr } = useAssignedAppTypeContext();
    const { getUserRoutes } = useUserRouteMapperHook();
    const panelItems = user && getUserRoutes(user);

    const containerStyle: CSSProperties = {
        height: '100%',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: isAmr ? 'auto 1fr' : '1fr'
    };

    return (
        <div style={containerStyle}>
            {isAmr && <NavTabsComponent panelItems={panelItems} />}
            <div style={outletStyle}>
                <Outlet />
            </div>
        </div>
    );
};
